// extracted by mini-css-extract-plugin
module.exports = {"boxVertical":"styles_boxVertical__uNwDH","boxHorizontal":"styles_boxHorizontal__4235E"};